import React, { Fragment, FunctionComponent } from "react";
import { BLOCK_TYPE } from "app/blocks/block.types";

import { Accordions, AccordionsProps } from "blocks/components/Accordions";
import { DownloadLinks, DownloadLinksProps } from "blocks/components/DownloadLinks";
import { Embed, EmbedProps } from "blocks/components/Embed";
import { Form, FormProps } from "blocks/components/Form";
import { Image, ImageProps } from "blocks/components/Image";
import { Quote, QuoteProps } from "blocks/components/Quote";
import { Text, TextProps } from "blocks/components/Text";
import { Video, VideoProps } from "blocks/components/Video";

const ModalBlock: FunctionComponent<BLOCK_TYPE> = (props) => {
    const renderControl = (props: BLOCK_TYPE): null | JSX.Element => {
        switch (props?.content?._contentType) {
            case "blockAccordions": {
                return (
                    <Accordions {...props as AccordionsProps} />
                );
            }
            case "blockDownloadLinksList": {
                return (
                    <DownloadLinks {...props as DownloadLinksProps} />
                );
            }
            case "blockEmbed": {
                return (
                    <Embed {...props as EmbedProps} />
                );
            }
            case "blockImage": {
                return (
                    <Image {...props as ImageProps} />
                );
            }
            case "blockQuote": {
                return (
                    <Quote {...props as QuoteProps} />
                );
            }
            case "blockText": {
                return (
                    <Text {...props as TextProps} />
                );
            }
            case "blockVideo": {
                return (
                    <Video {...props as VideoProps} />
                );
            }
            case "blockForm": {
                return (
                    <Form {...props as FormProps} />
                );
            }
            default: {
                return null;
            }
        }
    };

    return (
        <Fragment>
            {renderControl(props)}
        </Fragment>
    );
};

export default ModalBlock;